import { Post, SocialNetworkPostStatus, SourceType } from "./Post";
import { Campaign } from "./Campaign";
import { VideoProject } from "./VideoProject";
import { PlayerAccount } from "./Player";
import { Prompt } from "./Prompt";
import { SocialNetworksId } from "./SocialNetwork";
import { SemanticICONS } from "semantic-ui-react";

export type TimePeriod = "MONTH" | "WEEK";
export interface CalendarEvent {
  id: string;
  sourceId: number;
  sourceType: SourceType;
  sourceName: string;
  sourceTitle: string;
  scheduledDateTime: string;
  postStatuses: SocialNetworkPostStatus[];
  thumbnail: string | null;
  socialNetworkIds: SocialNetworksId[];
  promptIds: number[];
  playerIds: number[];
  regionIds: number[];
  branchIds: number[];
}
interface CalendarEventSource {
  sourceType: SourceType;
}
interface CalendarEventContentPage {
  contentPageId: number;
  slug: string;
  title: string;
  url: string;
}

export interface CalendarEventDetails {
  id: string;
  scheduledDateTime: string;
  posts: Post[];
  prompts: Prompt[];
  players: PlayerAccount[];
  source: CalendarEventSource & (Campaign | CalendarEventContentPage | VideoProject | Prompt | Post);
}
export interface CalendarEventFilters {
  sourceTypes: SourceType[];
  playerIds: number[];
  branchIds: number[];
  regionIds: number[];
  socialNetworkIds: SocialNetworksId[];
  statuses: SocialNetworkPostStatus[];
}

export const CALENDAR_EVENT_SOURCE_METADATA: Record<SourceType, { label: string; icon: SemanticICONS }> = {
  CAMPAIGN: {
    label: "Campaign",
    icon: "bullhorn",
  },
  CONTENT_PAGE: {
    label: "Video Page",
    icon: "file video",
  },
  VIDEO_PROJECT: {
    label: "Video Project",
    icon: "video",
  },
  PROMPT: {
    label: "Prompt",
    icon: "file",
  },
  POST: {
    label: "Post",
    icon: "map signs",
  },
  BLOG: {
    label: "Blog",
    icon: "newspaper outline",
  },
};
